import React, { useState } from "react";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { DriveUIActionTypes } from "src/common";
import { Pagination, PaginationDisplay, ToolbarWrapper, ToolbarFilter } from "src/components";

type AllProps = {
  // watched_logs?: WatchedLogEntity[];
  is_loading: boolean;
  pagination?: PaginationItem;
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { is_loading, pagination, handleAction } = props;
  const [filter_param, setFilterParam] = useState<string>("");

  // Description: reset filters on pagination and on click of x
  function resetFilters() {
    setFilterParam("");
    handleAction({ actionType: DriveUIActionTypes.Filter, params: "" });
  }

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={is_loading || !!pagination && pagination.totalRows === 0}
      placeholder="Filter by items name in this page..."
      filter_param={filter_param}
      onChange={(value) => { setFilterParam(value); handleAction({ actionType: DriveUIActionTypes.Filter, params: value }); }}
      onClick={resetFilters} />}
    pagination={!!pagination ? <Pagination pagination={pagination} handleAction={(params) => { resetFilters(); handleAction(params); }} /> : <></>}
    paginationInfo={!!pagination ? <PaginationDisplay pagination={pagination} /> : <></>}
    refreshAction={() => { resetFilters(); handleAction({ actionType: DriveUIActionTypes.Refresh }); }}
    isLoading={is_loading}
  />;
}

export default React.memo(ToolbarComponent);
